module.exports = __webpack_public_path__ + "resources/img/img-deep-security-02-5.df8cefd2460c1baa852a6a1ff5b05a37.png";